import { Component, Input } from '@angular/core';
import { UsefulLinkCard } from 'src/app/model/card/useful-link-card';

@Component({
  selector: 'app-useful-link-card',
  templateUrl: './useful-link-card.component.html',
  styleUrls: ['./useful-link-card.component.scss']
})
export class UsefulLinkCardComponent {
  @Input() usefulLinkCards: UsefulLinkCard[] = [];

  constructor() {}
}
